import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, inject, signal, viewChild } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { AddCpPaymentComponent } from 'src/app/AddThings/add-cp-payment/add-cp-payment.component';
import { AddPaymentModalComponent } from 'src/app/AddThings/add-payment-modal/add-payment-modal.component';
import { AddPrincipalComponent } from 'src/app/AddThings/add-principal/add-principal.component';
import { AddCommissionComponent } from 'src/app/Comission/add-commission/add-commission.component';
import { OverrideCommLimitComponent } from 'src/app/Comission/override-comm-limit/override-comm-limit.component';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE, INJECT_TYPE, SCHEME } from 'src/app/constants';
import { DialogItem } from 'src/app/dialog-item';
import { Customer } from 'src/model/customer.model';
import { FileInterface } from 'src/model/file.interface';
import { Loan } from 'src/model/loan.model';
import { Profile } from 'src/model/profile.model';
import { FormJService } from 'src/services/form-j.service';
import { LoanService } from 'src/services/loan.service';
import { ChangeLoanStatusComponent } from '../change-loan-status/change-loan-status.component';
import { LegacyEpfSettlementComponent } from '../legacy-epf-settlement/legacy-epf-settlement.component';
import { LoanArrearComponent } from '../loan-arrear/loan-arrear.component';
import { LoanDetailsComponent } from '../loan-details/loan-details.component';
import { LoanReserveComponent } from '../loan-reserve/loan-reserve.component';
import { MoveLoanComponent } from '../move-loan/move-loan.component';

@Component({
  selector: 'app-loan-card',
  templateUrl: './loan-card.component.html',
  styleUrls: ['./loan-card.component.scss'],
  standalone: false
})
export class LoanCardComponent implements OnInit {
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private loanService = inject(LoanService);
  private formJService = inject(FormJService);

  SCHEME = SCHEME;

  @Input() loan: Loan;
  @Input() selectedCustomer: Customer;
  @Input() reserveAmount: number;
  @Input() selectedProfile: Profile;
  @Input() needRestrictionCustomer: boolean;

  options = { hoverEnabled: false };
  tooltipOptions = {};

  @Input() isWithTransation = false;
  @Input() isSimplifiedView = false;

  loanTotalIncludeInterest = 0;
  loanBalance = 0;
  isEditing = false;
  loggedInCompanyId: number;

  fabOpen = false;

  loanFiles = signal<FileInterface[]>([]);
  addLoanDocTemplate = viewChild.required<TemplateRef<any>>('addLoanDoc');

  async ngOnInit(): Promise<void> {
    this.loanTotalIncludeInterest = this.sharedService.calculateTotalIncludeInterest(this.loan);
    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));
  }

  changeIsEditing(editing: boolean) {
    this.isEditing = editing;
  }

  updateLoan() {
    const data = {
      "principal": this.loan.Principal,
      "profileId": this.loan.ProfileId,
      "status": this.loan.Status,
      "interestRate": this.loan.InterestRate,
      "term": this.loan.Term,
      "scheme": this.loan.Scheme,
      "loanCode": this.loan.LoanCode
    }

    const xhr = this.restapi.putRequest(this.constructApi.getUpdateLoanDetail(this.loan.ID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        this.isEditing = false;
        this.sharedService.openAlert("Successfully updated loan code", ALERT_TYPE.SUCCESS)
      }
    }
  }

  setBalanceColor(loanBalance: number) {
    if (loanBalance <= 0)
      return 'green'
    else
      return 'red'
  }

  getLoanStatus(loanStatus: number) {
    if (loanStatus == this.enums.ACTIVE_LOAN)
      return "ACTIVE"
    else if (loanStatus == this.enums.WARNING_LOAN)
      return "WARNING"
    else if (loanStatus == this.enums.SETTLED_LOAN)
      return "SETTLED"
    else if (loanStatus == this.enums.BAD_DEBT_LOAN)
      return "BAD DEBT"
    else if (loanStatus == this.enums.LBD_LOAN)
      return "LEGAL"
    else
      return "CP";
  }

  getStatusColor(status: number) {
    let color: string;

    switch (status) {
      case this.enums.ACTIVE_CUST:
        color = "bg-primary";
        break;
      case this.enums.WARNING_CUST:
        color = "bg-warning";
        break;
      case this.enums.BAD_DEBT_CUST:
        color = "bg-dark";
        break;
      case this.enums.CP_CUST:
        color = "bg-info";
        break;
      case this.enums.LBD_CUST:
        color = "bg-secondary";
        break;
      default:
        color = "bg-success";
        break;
    }
    return color;
  }

  calculateBalance() {
    let balance = 0;

    if (this.loan.Scheme == "A") {
      balance = this.loan.Principal - this.loan.PrincipalPaid
    }
    else {
      balance = this.loanTotalIncludeInterest - this.loan.Repayment;
    }

    return this.roundTo2Dec(balance)
  }

  calculateMonthly() {
    let monthly = 0;

    // if (this.loan.Scheme == 'A') {
    //   var balance = this.calculateBalance();
    //   monthly = balance * (this.loan.InterestRate / 100);
    // }
    // else
    //   monthly = this.loanTotalIncludeInterest / this.loan.Term;

    if (this.loan.Scheme == 'A') {
      monthly = this.loan.InterestRate / 100 * this.loan.Principal;
    } else {
      monthly = this.loan.InterestRate / 100 * this.loan.Principal + (this.loan.Principal / this.loan.Term);
    }

    return monthly;
  }

  getIfEarning(earning: number) {
    if (earning > 0)
      return "bg-success"
    else
      return "bg-danger"
  }

  // calculateTotalIncludeInterest() {
  //   // this.loanTotalIncludeInterest = Number((this.loan.Principal * (this.loan.InterestRate / 100) * this.loan.Term).toFixed(2));
  //   // return this.loanTotalIncludeInterest;

  //   // this.loanTotalIncludeInterest = this.roundTo2Dec((this.loan.Principal * (this.loan.InterestRate / 100) * this.loan.Term))

  //   // this.loanTotalIncludeInterest = this.roundTo2Dec((this.loan.InterestRate / 100 * this.loan.Principal * this.loan.Term) + this.loan.Principal);
  //   return this.roundTo2Dec((this.loan.InterestRate / 100 * this.loan.Principal * this.loan.Term) + this.loan.Principal);
  // }

  roundTo2Dec(num: number) {
    return Math.round(num * 100) / 100
  }

  calculateProfitAndLoss(loan: Loan) {
    let pnl = 0;
    if (loan.Scheme == 'A')
      pnl = loan.PrincipalPaid + loan.InterestCharge + loan.ArrearPaid + loan.MonthlyInterest + loan.ProcessingCharge - loan.Principal + loan.Discount;
    else
      pnl = loan.Repayment + loan.InterestCharge + loan.ArrearPaid + loan.MonthlyInterest + loan.ProcessingCharge - loan.Principal + loan.Discount;

    return pnl;
  }

  isSharedLoan() {
    if (this.selectedCustomer != undefined)
      return this.selectedCustomer.CompanyId != this.loan.CompanyId;
    else
      return false;
  }

  openPaymentModal(loan: Loan) {
    const modalRef = this.sharedService.openModal(AddPaymentModalComponent);
    // modalRef.componentInstance.selectedLoanId = loanId;
    // modalRef.componentInstance.selectedLoanReceiptNo = loanReceipt;
    modalRef.componentInstance.selectedLoan = loan;
    modalRef.componentInstance.selectedCustomer = this.selectedCustomer;
  }

  openAddPrincipalModal(loan: Loan) {
    const modalRef = this.sharedService.openModal(AddPrincipalComponent, "largeModal");
    modalRef.componentInstance.selectedLoan = loan;
    modalRef.componentInstance.availableReserve = this.reserveAmount;
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });

    modalRef.result.then(() => {
    })
  }

  openChangeStatusModal(loan: Loan) {
    const modalRef = this.sharedService.openModal(ChangeLoanStatusComponent, "largeModal");
    modalRef.componentInstance.selectedLoan = loan;
  }

  openLoanDetailsModal(loan: Loan) {
    const modalRef = this.sharedService.openModal(LoanDetailsComponent, "largeModal");
    modalRef.componentInstance.selectedLoan = loan;
  }

  openPayWithReserveModal(loan: Loan, monthlyAmount: number) {
    if (this.reserveAmount <= 0) {
      this.sharedService.openAlert('You do not have SIMPAN for this customer', ALERT_TYPE.DANGER)
    } else {
      const modalRef = this.sharedService.openModal(LoanReserveComponent, "regularModal");

      this.loan.Reserve = this.sharedService.roundTo2Dec(this.reserveAmount);
      modalRef.componentInstance.selectedLoan = loan;
      modalRef.componentInstance.paymentAmount = this.roundTo2Dec(monthlyAmount);

      modalRef.componentInstance.passEntry.subscribe((entry) => {
        // this.loan = undefined;
        // var updatedLoanId = Number(entry);
        // this.getCustomerLoanInfo(updatedLoanId);

        this.refresh();
      });

      modalRef.result.then(() => {
        //detect changes
        this.cdr.detectChanges();
      })
    }
  }

  openLoanArrear(loan: Loan) {
    if (this.loan.Arrear <= 0) {
      this.sharedService.openAlert('You do not have ARREAR for this customer', ALERT_TYPE.DANGER)
    }
    else {
      const modalRef = this.sharedService.openModal(LoanArrearComponent);
      modalRef.componentInstance.selectedLoan = loan;

      modalRef.componentInstance.passEntry.subscribe((entry) => {
        // var updatedLoanId = Number(entry);
        // this.getCustomerLoanInfo(updatedLoanId);

        this.refresh();
      });

      modalRef.result.then(() => {
        //detect changes
        this.cdr.detectChanges();
      })
    }
  }
  confirmBeforeMoveCents() {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You sure you want to move all the cents in settlement charges into interest charge?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.moveCentsToInterestCharge();
    });

    return proceed;
  }

  moveCentsToInterestCharge() {
    const xhr = this.restapi.patchRequest(this.constructApi.getMoveCentsToInterest(this.loan.ID), {});
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        this.sharedService.openAlert("Successfully move all charges cents into interest charge", ALERT_TYPE.SUCCESS);
        window.location.reload();
      }
    }
  }

  confirmBeforeRemoveCP() {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You sure you want to remove this customer from CP?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.removeFromCP();
    });

    return proceed;
  }

  removeFromCP() {
    const xhr = this.restapi.putRequest(this.constructApi.getRemoveFromCP(this.loan.ID), {});
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        this.sharedService.openAlert("Successfully remove from CP", ALERT_TYPE.SUCCESS);
        window.location.reload();
      }
    }
  }

  openPaymentForBadDebt(loan: Loan) {
    const modalRef = this.sharedService.openModal(AddCpPaymentComponent);
    modalRef.componentInstance.selectedProfileId = loan.ProfileId;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      // this.loan = undefined;
      // var updatedLoanId = Number(entry);
      // this.getCustomerLoanInfo(updatedLoanId);

      this.refresh();
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

  openAddLegacySettlement(loan: Loan) {
    const modalRef = this.sharedService.openModal(LegacyEpfSettlementComponent, "regularModal");
    modalRef.componentInstance.loanList = [loan];

    //if completed
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const success = entry;

      //append added loan to loan list
      if (success)
        window.location.reload();
    });
  }

  confirmBeforeDeleteLegacySettlement(loanID: number) {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You sure you want to remove the legacy settlement?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteLegacySettlement(loanID);
    });

    return proceed;
  }

  deleteLegacySettlement(loanID: number) {
    const xhr = this.restapi.deleteRequest(this.constructApi.getAddLegacyEPFSettlement(Number(loanID)));

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (xhr.status == 200) {
            window.location.reload();
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }

  isSettled(loanStatus: number) {
    if (Number(loanStatus) == Number(this.enums.SETTLED_LOAN))
      return true;
    else
      return false;
  }

  isCP(loanStatus: number) {
    if (Number(loanStatus) == Number(this.enums.CP_LOAN))
      return true;
    else
      return false;
  }

  isBadDebt(loanStatus: number) {
    if (Number(loanStatus) == Number(this.enums.BAD_DEBT_LOAN))
      return true;
    else
      return false;
  }

  refresh(): void {
    window.location.reload();
  }

  openAddCommissionModal(loan: Loan) {
    if (this.sharedService.isAdmin() || this.sharedService.isBossAccount()) {
      const modalRef = this.sharedService.openModal(OverrideCommLimitComponent);
      modalRef.componentInstance.loan = loan;
      modalRef.componentInstance.loanGroupId = loan.LoanGroupId;
      modalRef.componentInstance.loanGroup = undefined;
    }
    else {
      const modalRef = this.sharedService.openModal(AddCommissionComponent);
      modalRef.componentInstance.loan = loan;

      modalRef.componentInstance.passEntry.subscribe((entry) => {
        window.location.reload();
      });

      modalRef.result.then(() => {
        //detect changes
        this.cdr.detectChanges();
      })
    }
  }

  defineLoanScheme() {
    if (this.loan.Scheme == 'EPF' || this.loan.IsEPF == true)
      return 'epfCard';
    else if (this.loan.Scheme == 'HUTANG')
      return 'hutangCard';
    else
      return 'loanCard';
  }

  openMoveLoanModal() {
    const modalRef = this.sharedService.openModal(MoveLoanComponent, "largeModal");
    modalRef.componentInstance.profileList = this.selectedCustomer.Profiles;

    modalRef.componentInstance.selectedProfile = this.selectedProfile;
    modalRef.componentInstance.selectedCustomer = this.selectedCustomer;
    modalRef.componentInstance.selectedLoan = this.loan;
  }

  openUploadLoanDocModal(loanId: number) {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.isLoanDocument = true;
    modalRef.componentInstance.loanId = loanId;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const loanId = Number(entry);

      if (loanId != undefined) {
        this.loan.LoanDocExisted = true;
        this.getLoanFiles();
      }
    });
  }

  openUploadStampedFormJ() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);
    modalRef.componentInstance.selectedCustomerId = this.selectedCustomer.ID;
    modalRef.componentInstance.isStampedFormJ = true;
    modalRef.componentInstance.formJId = this.loan.FormJ.Id;
    modalRef.componentInstance.formJStampDate = this.loan.FormJ.Date;

    modalRef.componentInstance.passEntry.subscribe((entry: Date) => {
      if (entry) {
        this.loan.FormJ.DateStamped = entry;
        this.loan.HasStampedFormJ = true;
      }
    });
  }

  async getLoanFiles() {
    const promises: Promise<FileInterface[]>[] = [this.loanService.getCustomerLoanAllFiles(this.selectedCustomer.ID, this.loan.ID)];
    if (this.loan.FormJ !== undefined) promises.push(this.formJService.getCustomerFormJFiles(this.selectedCustomer.ID, this.loan.FormJ.Id));
    const files = (await Promise.all(promises)).flat();
    this.loanFiles.update(f => f = [...files]);
  }

  async openViewLoanDocsModal(loanId: number) {
    await this.getLoanFiles();
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr = this.loanFiles;
    if (this.sharedService.isBranchManager())
      i.injectContent = [new DialogItem(this.addLoanDocTemplate(), { loanId: loanId }, INJECT_TYPE.TEMPLATE)];
  }

  isNonSettledEPFLoan() {
    return (this.loan.Status != this.enums.SETTLED_LOAN && (this.loan.Scheme == 'EPF' || this.loan.IsEPF == true));
  }
}
